import '@sprites/icon-sprite.svg?no-inline';

import { whenFound } from './utilities/component.js';

import Elements from './elements/index.js';
import Libraries from './libraries/index.js';

export default {
  get title() {
    return document.title;
  },

  set title(title) {
    document.title = `${title} · HOL’AB!`;
  },

  get direction() {
    return document.documentElement.dir || 'ltr';
  },

  get language() {
    return (document.documentElement.lang || 'de-DE').split('-').shift();
  },

  get region() {
    return (document.documentElement.lang || 'de-DE').split('-').pop();
  },

  install() {
    Libraries.install(this);
    Elements.install(this);

    whenFound('.site-header', (elements) => this.enhanceHeader(elements.at(0)));
    whenFound('a[href$=".jpg"], a[href$=".png"]', (elements) => this.enhanceGallery(elements));
  },

  /**
   * @param {HTMLHeaderElement} element
   */
  enhanceHeader(element) {
    const observer = new IntersectionObserver(([entry]) => {
      entry.target.classList.toggle('is-stuck', entry.intersectionRatio < 1);
    }, {
      threshold: [1],
    });

    observer.observe(element);
  },

  /**
   * @todo Replace with a proper lightbox component.
   * @param {HTMLElement[]} links
   */
  enhanceGallery(links) {
    links.forEach((link) => {
      link.addEventListener('click', function(event) {
        event.preventDefault();

        const fullScreenDiv = document.createElement('div');
        fullScreenDiv.classList.add('full-screen-image');

        const enlargedImage = document.createElement('img');
        enlargedImage.src = link.getAttribute('href');

        const closeButton = document.createElement('span');
        closeButton.textContent = '×';
        closeButton.classList.add('close-button');

        fullScreenDiv.appendChild(enlargedImage);
        fullScreenDiv.appendChild(closeButton);
        document.body.appendChild(fullScreenDiv);

        fullScreenDiv.addEventListener('click', function() {
          document.body.removeChild(fullScreenDiv);
        });

        const handleKeyDown = (event) => {
          if (event.key === 'Escape') {
            document.body.removeChild(fullScreenDiv);
          }
        };

        document.addEventListener('keydown', handleKeyDown);
      });
    });
  },

};
